import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdditionalPACData } from '../../models/additional-pac-data.model';
import { AppConstants } from '../../shared/app-constants';

@Component({
  selector: 'app-payment-collection-details',
  imports: [CommonModule, FormsModule],
  templateUrl: './payment-collection-details.component.html',
  styleUrl: './payment-collection-details.component.scss',
  standalone:true
})
export class PaymentCollectionDetailsComponent {
  today = new Date();

  @Input() pacDetails!: AdditionalPACData;

  constructor() {}

  showAmountFormatted(value: number | null | undefined): string {
    return AppConstants.showAmountFormatted(value);
  }

  get hasPaidItems(): boolean {
    return !!this.pacDetails?.paidLineItems?.length;
  }

  hasTransactionReference(): boolean {
    return this.pacDetails.paidLineItems?.some(item => item.transactionId != null) ?? false;
  }

  hasPaidLineItems(): boolean {
    return this.pacDetails.paidLineItems?.length != 0;
  }

  getPaymentMode(mode: string): string {
    return AppConstants.getPaymentMode(mode);
  }

}
